
{
  "hero": {
    "eyebrow": "Built for expats in Hong Kong",
    "title": "Find reliable Hong Kong service providers without the guesswork",
    "subtitle": "WhatsGood HK helps expats find local services faster, compare providers more easily, and contact them directly on WhatsApp.",
    "primaryCta": "Browse services",
    "secondaryCta": "List your business",
    "quickBrowseLabel": "Popular ways to start"
  },
  "trust": {
    "localLabel": "Built for Hong Kong",
    "localDesc": "A local directory shaped around the services people actually need.",
    "whatsappLabel": "Direct WhatsApp contact",
    "whatsappDesc": "Message providers directly when you are ready to enquire.",
    "profilesLabel": "Clear provider profiles",
    "profilesDesc": "See service areas, summaries, and categories before you decide.",
    "verificationLabel": "Verification and real reviews",
    "verificationDesc": "Trust cues only appear when they are backed by real product data."
  },
  "howItWorks": {
    "title": "How it works",
    "description": "A faster path from browsing to a confident shortlist.",
    "step1": {
      "title": "Discover",
      "description": "Browse providers by category, area, or service so you can narrow down quickly."
    },
    "step2": {
      "title": "Compare",
      "description": "Review useful details, trust cues, and service coverage before you decide who fits best."
    },
    "step3": {
      "title": "Connect",
      "description": "Message providers directly on WhatsApp when you are ready to ask about availability and pricing."
    }
  },
  "categories": {
    "title": "Popular categories",
    "description": "Start with the service you need most.",
    "viewAll": "View all services",
    "empty": "Popular categories will appear here soon."
  },
  "featured": {
    "title": "Featured providers",
    "description": "Browse selected local providers and contact them directly.",
    "viewAll": "View all providers",
    "empty": "Featured providers are being updated."
  },
  "providerCta": {
    "eyebrow": "For service providers",
    "title": "Create your listing and start getting direct enquiries",
    "description": "Create your listing, get direct enquiries on WhatsApp, and upgrade when you want more visibility across Hong Kong.",
    "benefit1": "Create your listing",
    "benefit2": "Get direct WhatsApp enquiries",
    "benefit3": "Upgrade when you want more visibility",
    "button": "List your business",
    "upgradeButton": "Upgrade for more visibility",
    "manageButton": "Add your listing"
  },
  "newToHK": {
    "title": "Need a service in Hong Kong?",
    "description": "Search providers by category, area or name, then contact them directly. WhatsGood HK is funded by provider subscriptions, not commissions on your enquiry.",
    "browseAll": "Browse services"
  }
}
